<template>
  <v-row dense class="text--primary body-1 font-weight-medium">
    <v-col cols="12" sm="3" class="d-flex align-center">
      <px-span-tooltip
        top
        :text="labelAprovacaoCodigo"
        :tooltip="tooltipAprovacaoCodigo"/>
      &nbsp;{{ aprovacao.comprador.pessoa.nome }}
    </v-col>
    <v-col cols="12" sm="3" class="d-flex align-center">
      {{ solicitante | truncate(25) }}
    </v-col>
    <v-col cols="12" sm="2" class="d-flex justify-center flex-column">
      {{ aprovacao.createdIn | date }}
      <small>
        Criado em
      </small>
    </v-col>
    <v-col cols="12" sm="2" class="d-flex justify-center flex-column">
      {{ aprovacao.dataEntrega | date }}
      <small>
        Prazo de entrega
      </small>
    </v-col>
    <v-col cols="12" sm="2" class="d-flex align-center justify-end">
      <div class="d-inline">
        <px-requisicao-urgencia-icon :urgencia="aprovacao.urgencia"/>
        <v-btn icon color="success" class="ml-1">
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn icon color="error">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <px-aprovacao-solicitacao-detalhes-modal-view :aprovacao-id="aprovacao.id"/>
        <v-btn icon>
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import AprovacaoSolicitacaoDetalhesModalView
  from '@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhesModalView.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    solicitante() {
      return this.aprovacao.usuario ? this.aprovacao.usuario.nome : this.aprovacao.nomeResponsavel;
    },
    labelAprovacaoCodigo() {
      return this.aprovacao.codigoInterno ? `(${this.aprovacao.codigoInterno} / ${this.aprovacao.id}) ` : `(${this.aprovacao.id}) `;
    },
    tooltipAprovacaoCodigo() {
      return this.aprovacao.codigoInterno ? 'Código ERP / Código Proxpect' : 'Código Proxpect';
    },
  },
  components: {
    pxAprovacaoSolicitacaoDetalhesModalView: AprovacaoSolicitacaoDetalhesModalView,
  },
};
</script>
